import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "sx"];
import { styled } from '@mui/material/styles';
var Root = styled('div')(function (_ref) {
    var theme = _ref.theme;
    return {
    // border: " 1px solid rgba(217, 217, 217, 1)",
    // margin: 10,
    // padding: 10,
    // borderRadius:"5px"
    //padding:"20px"
    };
});
export var MuiBox = function (props) {
    var children = props.children, className = props.className, sx = props.sx, others = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(Root, {
        sx: sx,
        className: className
    }, children);
};
